import React from "react";
import {Container} from "react-bootstrap";
import SalesFilterHeader from "../../Components/Statistics/SalesFilterHeader.jsx";
import useSalesFilters from "../../Components/Statistics/useSalesFilters.js";
import ParetoChart from "../../Components/Statistics/ParetoChart.jsx";
import TopArticlesChart from "../../Components/Statistics/TopArticlesChart.jsx";
import SlowMoversTable from "../../Components/Statistics/SlowMoversTable.jsx";
import TrendPanel from "../../Components/Statistics/TrendPanel.jsx";

/**
 * Renner & Penner - ABC/Pareto-Analyse, Top-Artikel, Ladenhüter und Trend,
 * seit August 2026 eine eigene Unterseite (siehe
 * StatisticsController::rennerPenner()). Fasst die Auswertungen zusammen,
 * die erkennen lassen, welche Artikel Lagerfläche belegen, deren Umsatz sie
 * nicht rechtfertigt - genau der fachliche Kern der ursprünglichen
 * Dashboard-Ansicht.
 */
export default function StatisticsRennerPenner() {
    const salesFilters = useSalesFilters();
    const {filters} = salesFilters;

    return (
        <Container fluid className="pt-2 pb-4">
            <SalesFilterHeader title="Renner & Penner" salesFilters={salesFilters}>
                <div className="d-flex flex-column gap-3">
                    <ParetoChart filters={filters} />

                    <SlowMoversTable filters={filters} />

                    <TopArticlesChart filters={filters} />

                    <TrendPanel filters={filters} />
                </div>
            </SalesFilterHeader>
        </Container>
    );
}
